import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store/index.js'      //模块化store
import store from './store'                  //单个store
//Vue.prototype.$store = store;              // 引入仓库的其他写法，也可以使用这个方法引入全局的变量、方法
import i18n from './assets/language/index.js'

import '@/assets/css/reset.css'            //样式初始化
import '@/assets/fonts/iconfont.css'       //线下阿里字符图标
//import '@/assets/fonts/iconfont.js'      //多色字符图标
import '@/assets/css/style.scss'           //p-开头的自定义框架样式
import '@/assets/css/public.scss'          //s-开头的共用样式（颜色相关）
import '@/assets/css/main.scss'            //项目样式
// import '@/assets/js/jquery2.0.0.min.js'

import Bridge from '@/utils/JSbridge.js'    // app和html通讯
Vue.prototype.$bridge = Bridge
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

// 引入全局组件，避免在每个页面都要引入公共组件------------------------------------------------------------------------------------------------
/*import cuCustom from '@/utils/lib/components/cu-custom.vue'
Vue.component('cu-custom', cuCustom)*/


// 手机端样式框架引入---------------------------------------------------------------------------------------------------------------------
/*import Mint from 'mint-ui'
Vue.use(Mint)
import 'mint-ui/lib/style.css'

import { Toast } from 'mint-ui';
Vue.prototype.$Toast = Toast;              //弹窗全局安装
import { MessageBox } from 'mint-ui';
Vue.prototype.$MessageBox = MessageBox;    //选择弹窗全局安装
import { Lazyload } from 'mint-ui';        //mint-ui中的懒加载
Vue.use(Lazyload);*/


// 电脑端框架引入-------------------------------------------------------------------------------------------------------------------------
/*import ElementUI from 'element-ui'
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css'*/


// 全局引入插件-----------------------------------------------------------------------------------------------------------------------------------
/*import axios from  'axios';
import time from 'js-time.js';    //操作时间的插件
import md5 from 'js-md5'          //md5加密
import Mshare from 'm-share'      //分享插件
import  html2canvas  from 'html2canvas'              //将html元素转换成图片，不支持在线图片
import qrcode from 'vue-mgqrcode'                    //将文字转换成二维码
import vuePicturePreview from 'vue-picture-preview'  //图片预览
Vue.use(vuePicturePreview)*/


Vue.config.productionTip = false;   // 生成环境时，是否多一行消息提示

// 全局引入插件-----------------------------------------------------------------------------------------------------------------------------------
import dialogMessage from './utils/dialogUtil.js';
Vue.prototype.$installdialog = dialogMessage.installDialog();

let  vm1 = new Vue({
  router,
  i18n, // 第二步：挂载 i18n插件
  store,
  render: h => h(App),
  created(){
      let  onoff = true;
      document.getElementsByTagName("html")[0].style.fontSize=document.documentElement.clientWidth/25 + "px";
      window.onresize=function(){
          if(  onoff  ){
              window.location.reload();//刷新当前页面.

              onoff = false;
              setTimeout(()=>{  onoff = true;  },1000);
          }
      };

  },
  mounted(){
      if(  store.state.isMobileDebug  ){
          // 初始化vConsole
          window.vConsole = new window.VConsole({
              defaultPlugins: ['system', 'network', 'element', 'storage', 'performance'], // 可以在此设定要默认加载的面板
              maxLogNumber: 1000,
              onReady: function() {
                  console.log('vConsole is ready.');
              },
              onClearLog: function() {
                  console.log('on clearLog');
              }
          });
      }
  },
  methods:{
    // Language(lan){
    //     this.$i18n.locale = lan
    //     localStorage.setItem('lang',lan)
    // }
  }
}).$mount('#app');


